<script setup>
import { formattedDate, humanizeText, parse_notification_description } from '@/helper';
import { onMounted, ref } from 'vue';


const props = defineProps({
  notification: {
    type: Object
  }
})

function get_description(){
  return parse_notification_description(props.notification)
}
</script>

<template>
  <div class="activity-dot-primary"></div>
  <div class="w-100 ms-3">
    <p class="d-flex justify-content-between mb-2">
      <span class="date-content light-background">
        {{formattedDate(notification.attributes.created_at, true)}}
      </span>
    </p>
    <div>
      <h6 class="text-capitalize">
        {{ humanizeText(notification.entity_type.attributes.entity) }}
        <span class="dot-notification"></span>
      </h6>
      <p class="f-light">
        {{ get_description() }}
      </p>

    </div>
  </div>
</template>
